//@ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from "react";
// import pageConfig from "@public/sampleConfig/checkout_details.json";
// import Renderer from "@parser/renderer";
//import test from "@public/sampleConfig/test.json";
import paymentConfig from "@public/sampleConfig/payment_node.json";
import revieConfig from "@public/sampleConfig/review-config.json";
import localConfig from "@public/sampleConfig/local.json";
import DiscountCnfig from "@public/sampleConfig/discount.json";
import { Renderer } from "@acko-sdui/ui-parser";
import widgetsMap from "@widgets/widgetsMap";
import actionsMap from "@actions/actionsMap";
import { wrapper } from "@store/store";
import { fetchConfig } from "@service/apiServices";
import {
  fetchConfigSuccess,
  fetchConfigFailure,
  fetchNormalisedConfigSuccess,
  updateShowCouponAnimation
} from "@store/slices/config";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/router";
import discountConfig from "@public/sampleConfig/discount.json";
import MMVconfig from "@public/sampleConfig/mmv-config.json";
import { fetchConfigAndRedirect } from "@actions/fetchConfigRedirect";
import DynamicLottie from "@components/common/Lottie/LottieAnimation";
import Chatbot from "@components/copilotChatbot";
import { getFromSessionStorage } from "@actions/getFromSessionStorage";
import AnimatedNumber from "@components/common/AnimatedNumber";
import CouponDiscountAnimation from "@components/common/AnimatedNumber";
// import ToastWrap from "@components/toast";
import ToastWrap from "@components/toastV2";
import { isEmpty } from "@utils/lodash";
import RegistraionNumberLottie from "@widgets/registrationNumberLottie";
import { setInSessionStorage } from "@actions/setInSessionStorage";
import { shouldResetEditJourney, checkIfRenewalPolicyPath, redirectToLoginIfNotLoggedIn } from "@utils/index";
import { NODES_WITHOUT_PROPOSAL_EKEY, OWNERSHIP_TRANSFER_OPTIONS_NODE } from "@utils/constants";
import { getUtmQueryParams } from "@utils/utm";

const useQueryParameters = () => {
  const router = useRouter();
  const {
    proposal_ekey,
    current_node,
    order_id,
    utm_source,
    utm_medium,
    utm_campaign,
    utm_content,
    utm_term
  } = router.query;
  const utmParams = useMemo(
    () => getUtmQueryParams(router.query),
    [utm_source, utm_medium, utm_campaign, utm_content, utm_term]
  );
  return {
    proposal_ekey,
    current_node,
    order_id,
    utmParams
  };
};

const Page = (props: any) => {
  // const { config } = props;
  // console.log({config});
  const dispatch = useDispatch();
  const {
    proposal_ekey,
    current_node,
    order_id,
    utmParams
  } = useQueryParameters();
  const {
    configResponse,
    showLottie,
    isLoading,
    showCouponAnimation,
    isNormalisedConfigSuccess,
    isSuccess,
    showLottieAnim,
    redirectionDone,
    nextNodeSuccess,
    isMmvDataFound,
    allState
  } = useSelector(({ configuration, lottieState }: any) => {
    return {
      configResponse: configuration?.config,
      //configResponse: test,
      showLottie: configuration.showLottie,
      isLoading: configuration?.isLoading,
      showCouponAnimation: configuration?.showCouponAnimation,
      isNormalisedConfigSuccess: configuration?.normalisedConfigSuccess,
      isSuccess: configuration?.isSuccess,
      showLottieAnim: lottieState?.showLottie,
      redirectionDone: lottieState?.redirectionDone,
      nextNodeSuccess: lottieState?.nextNodeSuccess,
      isMmvDataFound: lottieState?.isMmvDataFound,
      allState: lottieState
    };
  });

  const configNode = configResponse?.current_node;
  const router = useRouter();
  const isOwnershipTransferOptionsNode = current_node === OWNERSHIP_TRANSFER_OPTIONS_NODE;

  const [ownershipOptionsAuthReadyPath, setOwnershipOptionsAuthReadyPath] = useState("");
  const canFetchOwnershipNode = !isOwnershipTransferOptionsNode || ownershipOptionsAuthReadyPath === router.asPath;

  useEffect(() => {
    if (!router.isReady) {
      return;
    }
    const checkLoginForRenewalPolicy = async () => {
      if (checkIfRenewalPolicyPath()) {
        const isLoggedIn = await redirectToLoginIfNotLoggedIn();
        if (!isLoggedIn) {
          return;
        }
      }
    };
    
    checkLoginForRenewalPolicy();
  }, [router?.isReady, router?.asPath]);

  useEffect(() => {
    if (!isOwnershipTransferOptionsNode || !router.isReady) {
      setOwnershipOptionsAuthReadyPath("");
      return;
    }

    let cancelled = false;
    setOwnershipOptionsAuthReadyPath("");

    (async () => {
      const isLoggedIn = await redirectToLoginIfNotLoggedIn();
      if (!cancelled && isLoggedIn) {
        setOwnershipOptionsAuthReadyPath(router.asPath);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [router.isReady, router.asPath, isOwnershipTransferOptionsNode]);

  useEffect(() => {
    if (!isOwnershipTransferOptionsNode) {
      return;
    }
    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [isOwnershipTransferOptionsNode]);

  // useEffect(()=>{
  //   if (Object.keys(config)?.length > 0) {
  //   dispatch(fetchConfigSuccess(props?.config));
  //   }
  // },[config]);

  // Client side call
  const lastNodeRef = useRef();
  useEffect(() => {
    // Check if current_node is a landing page that doesn't require proposal_ekey
    const nodeWithOutEkey = NODES_WITHOUT_PROPOSAL_EKEY.includes(current_node);

    // Allow call if: current_node exists AND (proposal_ekey exists OR it's a landing page)
    if (current_node && (proposal_ekey || nodeWithOutEkey)) {
      if (!canFetchOwnershipNode) return;
      const payload = {
        requestBody: {
          previous_node: lastNodeRef.current,
          current_node: current_node,
          ...(current_node !== "entry_node" && { expected_node: current_node })
        },
        data: {
          ...(proposal_ekey && { proposal_ekey: proposal_ekey }),
          ...utmParams
        },
        ...(current_node === "entry_node" && {
          isRouterReplace: true,
          shouldRedirect: true
        }),
        ...(nodeWithOutEkey && {
          isRouterReplace: true,
          shouldRedirect: true
        })
      };
      console.log(payload.requestBody, "logging request body");

      // Reset edit journey session if navigating from addon/idv nodes to review nodes
      if (
        shouldResetEditJourney(current_node, payload.requestBody.previous_node)
      ) {
        setInSessionStorage({ key: "is_edit_journey", value: false });
      }

      if (
        !configResponse ||
        Object.keys(configResponse).length === 0 ||
        // this is to handle the back button scenario
        configNode !== current_node
      ) {
        fetchConfigAndRedirect(payload);
      }
      lastNodeRef.current = current_node;
    }
  }, [
    proposal_ekey,
    current_node,
    canFetchOwnershipNode,
    utmParams
  ]);

  useEffect(() => {
    if (current_node && order_id) {
      const payload = {
        requestBody: {
          previous_node: lastNodeRef.current,
          current_node: current_node,
          ...(current_node !== "entry_node" && { expected_node: current_node })
        },
        data: {
          order_id: order_id,
          ...utmParams
        },
        ...(current_node === "entry_node" && {
          isRouterReplace: true,
          shouldRedirect: true
        })
      };
      if (shouldResetEditJourney(current_node, payload.requestBody.previous_node)) {
        setInSessionStorage({ key: "is_edit_journey", value: false });
      }

      if (
        !configResponse ||
        Object.keys(configResponse).length === 0 ||
        configNode !== current_node
      ) {
        fetchConfigAndRedirect(payload);
      }
      lastNodeRef.current = current_node;
    }
  }, [
    current_node,
    order_id,
    utmParams
  ]);
  
  const { normalisedData, componentsTree } = useMemo(
    () => Renderer(configResponse, widgetsMap, actionsMap),
    [configResponse]
  );

  useEffect(() => {
    if (!isEmpty(normalisedData)) {
      dispatch(fetchNormalisedConfigSuccess(normalisedData));
    }
  }, [normalisedData]);

  useEffect(() => {
    if (isSuccess && isNormalisedConfigSuccess) {
      const { on_load } = configResponse?.actions?.on_load || [];
      if (on_load?.length > 0) {
        on_load?.forEach((eachFunc: any) => {
          typeof eachFunc.funCall === "function" &&
            eachFunc.funCall(eachFunc.args);
        });
      }
    }
  }, [configResponse, isSuccess, isNormalisedConfigSuccess]);

  // if found mmv show normal animation else reg lottie withc changed text
  const showWeFoundYourCarLottieInCngScreen =
    current_node === "cng_confirmation_node" && !isMmvDataFound;

  return (
    <div>
      {(current_node === "entry_node" && !redirectionDone) ||
      (showWeFoundYourCarLottieInCngScreen && showLottieAnim) ? (
        <RegistraionNumberLottie />
      ) : showCouponAnimation &&
        showLottieAnim &&
        configNode === current_node ? (
        <CouponDiscountAnimation
          showAnimation={showCouponAnimation && isLoading}
        />
      ) : (
        configNode === current_node && (
          <DynamicLottie
            showLottieAn={showLottie}
            isBackClicked={configNode !== current_node}
          />
        )
      )}
      {componentsTree()}
      <Chatbot />
      <ToastWrap />
      {/* <CouponDiscountAnimation /> */}
      {/* <Sample /> */}
      {/* <DynamicLottie /> */}
    </div>
  );
};

// export const getServerSideProps = wrapper.getServerSideProps(
//   (store) =>
//     async (ctx): Promise<any> => {
//       try {
//         // const state = store.getState();
//         // const config = state.configuration.config;

//         //to check the initial load of web page
//         const isInitialLoad = !ctx.req.headers.referer;

//         // if (!isInitialLoad) {
//         //   return {
//         //     props: {
//         //       config: {},
//         //     },
//         //   };
//         // }

//         const proposal_ekey = ctx?.query?.proposal_ekey;
//         const current_node = ctx?.query?.current_node;

//         const payload = {
//           current_node: current_node,
//           expected_node: current_node,
//           journey: "fresh_car",
//           data: {
//             origin: "acko",
//             product: "car",
//             is_new: "false",
//             proposal_ekey: proposal_ekey,
//           },
//         };

//         // const response = await fetchConfig(payload);

//         // store.dispatch(fetchConfigSuccess(response));

//         return {
//           props: {
//             config: {},
//           },
//         };
//       } catch (error: any) {
//         store.dispatch(fetchConfigFailure(error.message));
//         return {
//           props: {
//             config: null,
//           },
//         };
//       }
//     },
// );

export default Page;
